import { ChangeDetectionStrategy, Component, input } from '@angular/core';

let nextId = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-loading-spinner',
  standalone: true,
  host: {
    '[class.overlay]': 'overlay()',
  },
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--tds-size-spacing-600);
      }

      :host(.overlay) {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background-color: color-mix(
          in srgb,
          var(--tds-color-background-page) 60%,
          transparent
        );
        padding: 0;
      }

      .loading-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--tds-size-spacing-200);
      }

      .loading-spinner__svg {
        animation: spin 1.5s linear infinite;
      }

      .loading-spinner__label {
        color: var(--tds-color-foreground-secondary);
        font-size: var(--tds-font-size-body-2);
      }

      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ],
  template: `
    <div
      class="loading-spinner"
      role="status"
      [attr.aria-label]="label() || 'Loading'"
    >
      <svg
        class="loading-spinner__svg"
        xmlns="http://www.w3.org/2000/svg"
        [attr.width]="size()"
        [attr.height]="size()"
        viewBox="0 0 200 200"
      >
        <radialGradient
          [attr.id]="gradientId"
          cx=".66"
          fx=".66"
          cy=".3125"
          fy=".3125"
          gradientTransform="scale(1.5)"
        >
          <stop offset="0" stop-color="#1F49D2"></stop>
          <stop offset=".3" stop-color="#1F49D2" stop-opacity=".9"></stop>
          <stop offset=".6" stop-color="#1F49D2" stop-opacity=".6"></stop>
          <stop offset=".8" stop-color="#1F49D2" stop-opacity=".3"></stop>
          <stop offset="1" stop-color="#1F49D2" stop-opacity="0"></stop>
        </radialGradient>
        <circle
          fill="none"
          [attr.stroke]="'url(#' + gradientId + ')'"
          stroke-width="15"
          stroke-linecap="round"
          stroke-dasharray="200 1000"
          stroke-dashoffset="0"
          cx="100"
          cy="100"
          r="70"
        ></circle>
        <circle
          fill="none"
          opacity=".2"
          stroke="#1F49D2"
          stroke-width="15"
          stroke-linecap="round"
          cx="100"
          cy="100"
          r="70"
        ></circle>
      </svg>
      @if (label()) {
        <span class="loading-spinner__label">{{ label() }}</span>
      }
    </div>
  `,
})
export class LoadingSpinnerComponent {
  size = input<number>(48);
  label = input<string>('');
  overlay = input<boolean>(false);

  protected readonly gradientId = `spinner-gradient-${nextId++}`;
}
